var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationStatu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8C20.6569 8 22 6.65685 22 5C22 3.34315 20.6569 2 19 2C17.3431 2 16 3.34315 16 5C16 6.65685 17.3431 8 19 8Z",
    fill: "url(#paint0_linear_406_14092)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 9.5C17.8073 9.49736 16.6643 9.0224 15.8209 8.17906C14.9776 7.33572 14.5026 6.19266 14.5 5C14.51 4.30367 14.6812 3.61912 15 3H7C5.67392 3 4.40215 3.52678 3.46447 4.46447C2.52678 5.40215 2 6.67392 2 8V17C2 18.3261 2.52678 19.5979 3.46447 20.5355C4.40215 21.4732 5.67392 22 7 22H16C17.3261 22 18.5979 21.4732 19.5355 20.5355C20.4732 19.5979 21 18.3261 21 17V9C20.3809 9.31884 19.6963 9.48998 19 9.5Z",
    fill: "url(#paint1_linear_406_14092)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5005 14H6.81055C6.61163 14 6.42087 13.921 6.28022 13.7803C6.13956 13.6397 6.06055 13.4489 6.06055 13.25C6.06055 13.0511 6.13956 12.8603 6.28022 12.7197C6.42087 12.579 6.61163 12.5 6.81055 12.5H11.5005C11.6995 12.5 11.8902 12.579 12.0309 12.7197C12.1715 12.8603 12.2505 13.0511 12.2505 13.25C12.2505 13.4489 12.1715 13.6397 12.0309 13.7803C11.8902 13.921 11.6995 14 11.5005 14Z",
    fill: "url(#paint2_linear_406_14092)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5005 18H6.81055C6.61163 18 6.42087 17.921 6.28022 17.7803C6.13956 17.6397 6.06055 17.4489 6.06055 17.25C6.06055 17.0511 6.13956 16.8603 6.28022 16.7197C6.42087 16.579 6.61163 16.5 6.81055 16.5H15.5005C15.6995 16.5 15.8902 16.579 16.0309 16.7197C16.1715 16.8603 16.2505 17.0511 16.2505 17.25C16.2505 17.4489 16.1715 17.6397 16.0309 17.7803C15.8902 17.921 15.6995 18 15.5005 18Z",
    fill: "url(#paint3_linear_406_14092)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_14092",
    x1: 16,
    y1: 5,
    x2: 22,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_406_14092",
    x1: 2,
    y1: 12.5,
    x2: 21,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_406_14092",
    x1: 6.06055,
    y1: 13.25,
    x2: 12.2505,
    y2: 13.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_406_14092",
    x1: 6.06055,
    y1: 17.25,
    x2: 16.2505,
    y2: 17.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65CA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationStatu);
export default __webpack_public_path__ + "static/media/notification-statu.907594a34fbad03194009011bb73050a.svg";
export { ForwardRef as ReactComponent };